<script lang="ts">
    import wishlist from '../store/wishlist';
    import Wishlist from './wishlist/Wishlist.svelte';

    let count = wishlist.count;

    $: count, wishlist.init();

    let show = false;

    const hide = () => {
        show = false;
    };
</script>

<div class="cart-wrapper">
    {#if show == true}
        <Wishlist {hide} />
    {/if}

    <button
        class="cart-info d-flex justify-content-center align-items-center"
        on:click={() => (show = !show)}
    >
        {#if $count > 0}
            <div class="cart-count">{$count}</div>
        {/if}
        <i class="fas fa-shopping-basket" style="" />
    </button>
</div>

<style>
    .cart-info {
        height: 70px;
        width: 70px;
        background-color: #113817;
        border-radius: 30px;
        border: 1px solid #113817;
        font-size: 30px;
        line-height: 20px;
        padding: 14px 12px;
        color: white;
        cursor: pointer;
        position: relative;
        float: right;
        display: inline-block;
        box-shadow: 0px 1px 1px rgb(0 0 0 / 25%), 0 5px 5px rgb(0 0 0 / 22%);
        transition: all 0.3s;
    }

    .cart-info:hover {
        background-color: rgba(36, 119, 49);
        font-size: 35px;
        padding: 5px;
        transition: all 0.3s;
    }

    .cart-wrapper {
        position: fixed;
        bottom: 30px;
        right: 110px;
        z-index: 2001;
        width: 94vw;
        max-width: 340px;

        display: inline-block;
        width: auto;
    }

    @media screen and (max-width: 768px) {
        .cart-wrapper {
            bottom: 10px;
            right: 70px;
        }

        .cart-info {
            height: 50px;
            width: 50px;
        }

        .fa-shopping-basket {
            font-size: 20px;
        }
    }

    .cart-count {
        position: absolute;
        top: 1px;
        right: -2%;
        height: 20px;
        line-height: 20px;
        width: 20px;
        background-color: red;
        border-radius: 20px;
        color: white;
        font-family: inherit;
        text-align: center;
        font-size: 0.7rem;
    }
</style>
